import React from "react";
import { useForm } from "@/src/provider/Form/FormProvider";
import DateFieldConfigured from "@/src/components/Form/ConfiguredFormElements/DateFieldConfigured/DateFieldConfigured";
import { FormHeaderWrapper } from "@/src/components/Form/Common/FormHeaderWrapper/FormHeaderWrapper";
import TextFieldConfigured from "@/src/components/Form/ConfiguredFormElements/TextFieldConfigured/TextFieldConfigured";
import RadioGroupConfigured from "@/src/components/Form/ConfiguredFormElements/RadioGroupConfigured/RadioGroupConfigured";
import { ContractDetailsProps } from "@/src/types/ContractDetailsProps";
import Grid from "@mui/material/Grid";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import MobileProvidersAutocomplete from "@/src/components/Form/MobileProvidersAutoComplete/MobileProvidersAutocomplete";

export default function DataLeakContractDetails({ product, submitProps }: ContractDetailsProps) {
  const { values, handleSubmit }: any = useForm();
  return (
    <FormHeaderWrapper submitProps={submitProps} handleSubmit={handleSubmit}>
      <Grid size={12}>
        <FormLegend>Bei welchem Mobilfunkanbieter sind Sie?</FormLegend>
        <MobileProvidersAutocomplete name={"mobileProviderOrganizationId"} requiredMessage={"Bitte gib deinen aktuellen Mobilfunkanbieter an"} />
      </Grid>
      <TextFieldConfigured caseData={product} fieldPath={"contractNumber"} required />
      <RadioGroupConfigured caseData={values} fieldPath={"salesChannel"} required />
      <Grid size={12}>
        <FormLegend>Für die SCHUFA / CRIF-Anfrage benötigen wir zudem noch Ihr Geburtsdatum.</FormLegend>
      </Grid>
      <DateFieldConfigured caseData={values} fieldPath={"customer.person.birthDate"} dateValidation={"past"} required />
    </FormHeaderWrapper>
  );
}
